import { ComponentType, useState } from 'react';
import { ReplyQuestionFormProps, ReplyQuestionFormPropsWithOpened } from './ReplyQuestionForm';

export function withOpened(
	Component: ComponentType<ReplyQuestionFormPropsWithOpened>,
): ComponentType<ReplyQuestionFormProps> {
	return (props) => {
		const [opened, setOpened]
				= useState(false);

		return (
			<Component
				key={String(opened)}
				opened={opened}
				onOpened={setOpened}
				{...props}
			/>
		);
	};
}
